<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getExpenses"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-2">Item</div>
        <div class="col-md-2">Date</div>
      <div class="col-md-4">Description</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-2">Damage</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2 my-auto">
          <p class="m-0">{{ slotProps.item.item }}</p>
        </div>

        <div class="col-md-2 my-auto">
          {{
            moment(new Date(slotProps.item.expense_date)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

        <div class="col-md-4 my-auto">
         <p class="m-0">{{ slotProps.item.description }}</p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0 text-primary">{{ slotProps.item.amount | currency }}</p>
        </div>

        <div class="col-md-2 my-auto">
           <p class="m-0" v-if="slotProps.item.tenant">{{ slotProps.item.tenant.name }}</p>
        </div>

      </template>
    </data-table>

  </div>
</template>

<script>
import propertyRepo from "@/api/repos/propertyRepo";
import dataTable from "@/components/common/DataTable";


export default {
  props: ["propertyId"],

  components: {
    dataTable,
  },

  data() {
    return {
      expenseShow: false,
      selectedExpense: null,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getExpenses({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getExpenses(e) {
      this.isLoad = true;
      try {
        let { data } = await propertyRepo.propertyExpenses(
          this.propertyId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.expenses.data;
        this.totalRows = data.expenses.total;
        this.page = data.expenses.current_page;
        this.fromRow = data.expenses.from;
        this.toRow = data.expenses.to;
        this.lastPage = data.expenses.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async markPaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 1;
        }
      });
      try {
        await propertyRepo.expensePaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 0;
          }
        });
      }
    },
    async markUnpaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 0;
        }
      });
      try {
        await propertyRepo.expenseUnpaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 1;
          }
        });
      }
    },
     printExpense(job,uid){
     window.open(`/pdf/reports/job/${job.uid}/expense/${uid}?cid=${job.company_id}`)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
